import { routers } from "../app.js"

let actions = {
    API({ commit }, inputs) {
        return new Promise((resolve, reject) => {
            var options = {
                method: inputs.method,
                url: inputs.url
            };

            if (localStorage.getItem("token")) {
                options.headers = {
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                };
            }

            if (inputs.method == 'get') {
                options.params = inputs;
            } else {
                if (inputs.is_form_data) {
                    let formData = new FormData();

                    for (const key in inputs) {
                        const element = inputs[key];
                        formData.append(key, element);
                    }
                    options.headers = {
                        'Content-Type': 'multipart/form-data'
                    };
                    options.data = formData;

                } else {
                    options.data = inputs;

                }
            }

            axios(options)
                .then(res => {
                    //
                    if (res.data.message) {
                        Vue.default.toasted.success(res.data.message);
                    }
                    resolve(res.data);
                }).catch(err => {
                    //

                    if (err.response.status == 401) {
                        localStorage.removeItem('token');
                        routers.push({ path: '/admin/login' });
                    } else {
                        var error = "An error has occured.";
                        if (err.response.status == 422) {
                            if (err.response.data instanceof Array) {
                                error = "";
                                err.response.data.forEach((message) => {
                                    error += message + "<br>";
                                });
                            } else if (err.response.data.errors != null) {
                                var get_error = err.response.data.errors;
                                for (var a in get_error) {
                                    error += "<br>" + get_error[a][0] + "";
                                }
                            } else if (err.response.data.message != null) {
                                error = err.response.data.message;
                            }
                        }
                        Vue.default.toasted.error(error);
                        reject(err);
                    }
                });
        });
    },
}
export default actions
